import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';
import miscUtils from '../../../utils/miscUtils';

class DocMoneyEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 id="money" className="heading-1">PAYMENT_CARD</h3>
                    <div className="description">
                        The payment card extraction is designed to validate and categorize credit card numbers efficiently while 
                        ensuring data integrity through multiple checks. It begins by matching potential card numbers from the 
                        text using a strict pattern that accommodates various formats, including optional spaces or dashes. 
                        To validate authenticity, the system applies the Luhn algorithm, a checksum formula used by financial 
                        institutions to detect errors.
                        <div className="note">
                            <span className="fa fa-info-circle fa-xl">&nbsp;</span>
                            For Luhn check, see: <a href="https://en.wikipedia.org/wiki/Luhn_algorithm">Luhn Algorithm</a>
                        </div>
                        Once extracted, the numbers are classified based on their BIN (first 6 digits), allowing for the determination 
                        of card types such as Visa, Mastercard, American Express, Discover, Diners Club, etc.  The final output presents
                        the standardized card number in a consistent format, ensuring it is correctly structured and easy to read. 
                        Additionally, if the BIN could be identified, the extraction will be further enriched with attributes containing 
                        details associated with the card number.

                        <br/>
                        <br/>
                        An extracted Payment Card may be represented by the following attributes:
                        <br/>
                        All attributes are optional and may not be present
                    </div>

                    <table className="table-wrapper">
                        <thead className="table-header">
                        <tr>
                            <th>Attribute </th>
                            <th>Meaning </th>
                            <th>Type </th>
                            {/* <th>Constraints </th> */}
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">category</td>
                            <td className="meaning">The category of the card number. This is often whether the card is considered 
                                personal or corporate but may be more specific like Classic, Gold, Platinum.</td>
                            <td className="type">String</td>
                            {/* <td className="constraints">Mandatory</td> */}
                         
                        </tr>
                        <tr>
                            <td className="attribute">brand</td>
                            <td className="meaning">The brand of the card. 
                                This will commonly be Visa, Mastercard, American Express, Discover, Diners Club, etc.</td>
                            <td className="type">String</td>
                            {/* <td className="constraints">Mandatory</td> */}
                            
                        </tr>
                        <tr>
                            <td className="attribute">issuer</td>
                            <td className="meaning">The institution that issued the card. </td>
                            <td className="type">String</td>
                            {/* <td className="constraints">Optional</td> */}
                        </tr>
                        <tr>
                            <td className="attribute">issuerUrl</td>
                            <td className="meaning">A url associated with the institution that issued the card.</td>
                            <td className="type">String</td>
                            {/* <td className="constraints">Optional</td> */}

                        </tr>
                        <tr>
                            <td className="attribute">issuerPhone</td>
                            <td className="meaning">A url associated with the institution that issued the card.</td>
                            <td className="type">String</td>
                            {/* <td className="constraints">Mandatory</td> */}
                        </tr>
                        <tr>
                            <td className="attribute">cardType</td>
                            <td className="meaning">The type of payment card. Indicates whether the card is credit, debit, gift, etc.</td>
                            <td className="type">String</td>
                            {/* <td className="constraints">Optional</td> */}
                        </tr>
                        <tr>
                            <td className="attribute">countryName</td>
                            <td className="meaning">The name of the country where the card issuer is located.</td>
                            <td className="type">String</td>
                            {/* <td className="constraints">Optional</td> */}
                        </tr>
                        <tr>
                            <td className="attribute">isoCode2</td>
                            <td className="meaning">The ISO 3166-1 alpha-2 country code of the card issuer.</td>
                            <td className="type">String</td>
                            {/* <td className="constraints">Optional</td> */}
                        </tr>
                        <tr>
                            <td className="attribute">isoCode3</td>
                            <td className="meaning">The ISO 3166-1 alpha-3 country code of the card issuer.</td>
                            <td className="type">String</td>
                            {/* <td className="constraints">Optional</td> */}
                        </tr>
                        </tbody>
                    </table>

                    <h4 className="heading-2">Examples</h4>
                    Card number shown below are as an example only.

                    <div className="example-content host">
                        INPUT:
                        <pre>Card Number: 6011 1111 1111 1117</pre>
                        <br/>
                        OUTPUT:
                        <pre>{JSON.stringify({
                            'entities': [
                                {
                                    'label': '6011 1111 1111 1117',
                                    'type': 'PAYMENT_CARD',
                                    'count': 1,
                                    'attributes': {
                                        'issuerUrl': 'https://www.discover.com',
                                        'isoCode2': 'US',
                                        'isoCode3': 'USA',
                                        'cardType': 'CREDIT',
                                        'countryName': 'UNITED STATES',
                                        'category': 'PERSONAL',
                                        'brand': 'DISCOVER',
                                        'issuerPhone': '+18003477000',
                                        'issuer': 'DISCOVER BANK'
                                    }
                                }
                            ]
                        }, null, 3)}</pre>
                    </div>
                    {/* <HttpRunner example="money1"
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_MONEY1) : null}
                    />
                    <br/>
                    <div className="example-content">Foreign Currency: 156 billion rubles</div>
                    <HttpRunner example="money2" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_MONEY2) : null}
                    /> */}
                </div>
            </div>
        );
    }
}

export default DocMoneyEntity;